import { createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-ad5acc98"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "about-if-root-page main-scroll-topbar-content"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://summit-img.geekpark.net/if2023/about_if_top.png"
}, null, -1));

const _hoisted_3 = {
  class: "home-video-box"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "home-video-box-bg",
  src: "https://summit-img.geekpark.net/if2023/aboutif_home_video_bg_4.jpg"
}, null, -1));

const _hoisted_5 = {
  class: "home-video-container"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  type: "video/mp4",
  src: "https://summit-img.geekpark.net/if2023/about_if.mp4"
}, null, -1));

const _hoisted_7 = [_hoisted_6];

const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<img src=\"https://summit-img.geekpark.net/if2023/home_allif_1.png\" data-v-ad5acc98><img src=\"https://summit-img.geekpark.net/if2023/home_allif_2.png\" data-v-ad5acc98><div class=\"other-if-box\" data-v-ad5acc98><img src=\"https://summit-img.geekpark.net/if2023/about_if_content_6.png\" data-v-ad5acc98><div class=\"other-if-item-box\" data-v-ad5acc98><div class=\"other-if-item\" data-v-ad5acc98><a class=\"other-if-text\" href=\"https://if2015.geekpark.net/\" data-v-ad5acc98>2015</a><a class=\"other-if-text\" href=\"https://if2016.geekpark.net/\" data-v-ad5acc98>2016</a></div><div class=\"other-if-item\" data-v-ad5acc98><a class=\"other-if-text\" href=\"http://if2017.geekpark.net/\" data-v-ad5acc98>2017</a><a class=\"other-if-text\" href=\"http://if2018.geekpark.net/\" data-v-ad5acc98>2018</a></div><div class=\"other-if-item\" data-v-ad5acc98><a class=\"other-if-text\" href=\"https://if2019.geekpark.net/\" data-v-ad5acc98>2019</a><a class=\"other-if-text\" href=\"https://if2020.geekpark.net/\" data-v-ad5acc98>2020</a></div><div class=\"other-if-item\" data-v-ad5acc98><a class=\"other-if-text\" href=\"https://if2021.geekpark.net/\" data-v-ad5acc98>2021</a><a class=\"other-if-text\" href=\"https://if2022.geekpark.net/\" data-v-ad5acc98>2022</a></div></div></div><img src=\"https://summit-img.geekpark.net/if2023/footer_2.png\" data-v-ad5acc98>", 4);

import TopNavigator from "../components/TopNavigator.vue";
import { ref, onMounted, onBeforeUnmount } from "vue";
export default {
  __name: 'AboutIF',
  props: {},

  setup(__props) {
    const props = __props;
    onMounted(() => {
      video.value && video.value.addEventListener("play", handlePlay); //监听滚动

      window.addEventListener("scroll", handleScroll, true);
    });
    onBeforeUnmount(() => {
      video.value && video.value.pause(); //暂停视频

      window.removeEventListener("scroll", handleScroll, true);
    }); // 视频播放

    const isFirst = ref(false);
    const video = ref(null); //视频播放状态

    const handlePlay = () => {
      if (!isFirst.value) {
        video.value.pause();
        video.value.play();
        isFirst.value = true;
      }
    }; //页面滚动


    const handleScroll = () => {
      video.value && video.value.pause(); //暂停视频
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(TopNavigator, {
        title: "关于 IF"
      }), _createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("video", {
        class: "home-video-player",
        ref_key: "video",
        ref: video,
        poster: "https://summit-img.geekpark.net/if2023/about_if_cover_img.jpg",
        controlslist: "nodownload noremoteplayback",
        controls: "controls",
        disablePictureInPicture: "",
        loop: "",
        "webkit-playsinline": "",
        playsinline: "",
        "x5-playsinline": ""
      }, _hoisted_7, 512)])]), _hoisted_8])], 64);
    };
  }

};